import React from 'react'
import { FieldPage, FOCUS } from '~components/FieldPage'
import { PasswordIdentifyStep } from '~components/PasswordIdentifyStep'

const PasswordIdentifyPage = () => (
  <FieldPage status={FOCUS}>
    <PasswordIdentifyStep />
  </FieldPage>
)

export { PasswordIdentifyPage }
